<template>
  <div
    id="app"
    class="page-container">
    <md-app
      md-waterfall
      md-mode="fixed">
      <md-app-toolbar class="md-primary">
        <Header/>
      </md-app-toolbar>

      <md-app-drawer
        md-permanent="full"
        class="md-elevation-8">
        <SideBar/>
      </md-app-drawer>

      <md-app-content>
        <router-view/>
        <md-snackbar
          md-position="center"
          :md-duration="messageDuration"
          :md-active="isMessageDisplayed"
          @update:mdActive="hideMessage"
          md-persistent>
          <span>{{ messageLabel }}</span>
          <p>{{ messageDescription }}</p>
          <md-button
            class="md-primary"
            @click="hideMessage">Fermer</md-button>
        </md-snackbar>
        <md-dialog
          :md-fullscreen='false'
          :md-active="isErrorDisplayed">
          <md-dialog-title>{{ errorTitle }}</md-dialog-title>
          <md-dialog-content v-html="errorMessage" />
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="hideError()">
              Fermer
            </md-button>
          </md-dialog-actions>
        </md-dialog>
      </md-app-content>
    </md-app>

    <BlockUI
      v-if="isLoading"
      :message="msg">
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="7"
        md-mode="indeterminate" />
    </BlockUI>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'

import session from './api/session'
import SideBar from './components/SideBar.vue'
import Header from './components/Header.vue'
import BlockUI from 'vue-blockui'
import Vue from 'vue'

Vue.use(BlockUI)

export default {
  name: 'App',
  components: {
    SideBar,
    Header
  },
  data () {
    return {
      msg: 'Chargement...'
    }
  },
  mounted () {
    // Refresh notifications data every 3 seconds
    this.updateNotifications()
    this.notificationsRefreshTimer = setInterval(this.updateNotifications, 3000)
  },
  destroyed () {
    // The timer must be stopped when the component is destroyed otherwise it will continue to run
    clearInterval(this.notificationsRefreshTimer)
  },
  computed: {
    ...mapState({
      'isMessageDisplayed': state => state.messages.isDisplayed,
      'messageLabel': state => state.messages.label,
      'messageDescription': state => state.messages.description,
      'messageDuration': state => state.messages.duration,
      'isErrorDisplayed': state => state.errors.isDisplayed,
      'errorMessage': state => state.errors.message,
      'errorTitle': state => state.errors.title
    }),
    ...mapGetters('loading', ['isLoading'])
  },
  methods: {
    ...mapMutations({
      showMessage: 'messages/SHOW',
      hideMessage: 'messages/HIDE',
      showError: 'errors/SHOW',
      hideError: 'errors/HIDE'
    }),
    hideError () {
      this.$store.commit('errors/HIDE', {})
    },
    async updateNotifications () {
      const notificationsResponse = await session.get('/api/notifications/')
      const notifications = notificationsResponse.data
      this.$store.commit('notifications/SET_NOTIFICATIONS', notifications)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue